// extracted by mini-css-extract-plugin
export default {"fill-placeholder-child":"fill-placeholder-child_PBF8b","loading-wrap":"loading-wrap_zApf9","loading":"loading_2fXNS"};